/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Box, Text, Tag, TagLabel, Button, Input } from "@chakra-ui/react";
import { IoIosClose } from "react-icons/io";
import CustomModal from "../../../Common/CustomModal/CustomModal";
import { IoAddCircle } from "react-icons/io5";

const SecurityCityBox = ({ tribe, onAddCity, onDeleteCity }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newCity, setNewCity] = useState("");

  const handleOpenModal = () => {
    setNewCity("");
    setIsModalOpen(true);
  };

  const handleSave = () => {
    if (newCity.trim()) {
      onAddCity(newCity.trim());
    }
    setIsModalOpen(false);
    setNewCity("");
  };

  return (
    <Box my={16}>
      <Box mb={2} mt={10} display="flex" alignItems="center" gap={2}>
        <Text fontWeight="bold">CITY :</Text>
        <IoAddCircle cursor="pointer" onClick={handleOpenModal} />
      </Box>

      <Box
        display="flex"
        flexWrap="wrap"
        gap={2}
        maxH={{ base: "150px", md: "200px" }}
        overflowY="auto"
      >
        {tribe?.CITY.map((city, idx) => (
          <Tag
            key={idx}
            size="lg"
            variant="primary"
            gap={2}
            position="relative"
            _hover={{
              "& .icon-wrapper": { visibility: "visible" },
            }}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <TagLabel fontWeight="normal">{city}</TagLabel>
            <Box
              display="flex"
              gap={2}
              alignItems="center"
              className="icon-wrapper"
              visibility="hidden"
            >
              <IoIosClose
                fontSize="18px"
                cursor="pointer"
                onClick={() => onDeleteCity(idx)}
              />
            </Box>
          </Tag>
        ))}
      </Box>

      <CustomModal
        size="md"
        isCentered={true}
        title="Add City"
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        bodyContent={
          <>
            <Input
              placeholder="City Name"
              value={newCity}
              onChange={(e) => setNewCity(e.target.value)}
            />

            <Box mt={2} textAlign="right">
              <Button onClick={handleSave} variant="primaryButton">
                Save
              </Button>
            </Box>
          </>
        }
      />
    </Box>
  );
};

export default SecurityCityBox;
